<n-card :id="cardId" @click="onCardClick" @keydown.enter="onCardKeydown" @keydown.space.prevent="onCardKeydown" :role="clickable ? 'button' : null" :tabindex="clickable ? 0 : null" :aria-label="clickable ? actionProps.ariaLabel || title : null" :wrapper-class="[
    styles.card,
    cardClassName,
    { [styles.clickable]: clickable },
    'n-p-xl n-flex n-flex-column n-border-1 n-border-color-neutral-300 n-radius-lg n-shadow-none'
  ]">
  <div class="n-flex n-flex-column n-gap-3xl n-flex-grow">
    <NIconFeatured v-if="showIcon" :name="iconName" circle  size="lg" />

    <NTypography as="h6" variant="text-lg" weight="bold"
      :class="[styles.title, 'n-break-word']">
      {{ title }}
    </NTypography>
    <n-tooltip v-if="showTooltip" :tooltip-text="description" max-width="300px"
      position="bottom">
      <NTypography as="p" variant="text-md"
        :class="[styles.description , '  n-flex-grow']">{{ description }}
      </NTypography>
    </n-tooltip>
    <NTypography v-else as="p" variant="text-md" class="n-flex-grow">{{
      description }}</NTypography>
    <n-status-tag v-if="category"
      wrapper-class="n-border-1 n-radius-sm n-border-color-neutral-200"
      :rounded="false" :showIndicator="false" :label="category" variant="subtle"
      color="neutral" size="md" />

    <slot name="actions" v-if="enableActions">
      <n-btn :class="styles.navigation" @click.stop="onActionClick()"
        :id="cardActionId" size="md" variant="primary">
        {{$t('useTheService')}}
      </n-btn>
    </slot>
  </div>
</n-card>